import React from "react";
import ContactUsSection from "../components/ContactUs/ContactUs.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const ContactUs = () => {
  return (
    <div>
                    <MetaComponent
        title="Aptech Limited: Corporate Offices and Business Contacts Information"
        desc="Explore Aptech's contact details for Mumbai Head Office, corporate offices, and regional offices. Reach out for retail, corporate, and customer care inquiries. "
        keywords="aptech contact details, aptech training solutions, aptech customer care"
      />
      <ContactUsSection />
    </div>
  );
};

export default ContactUs;
